import React, { useEffect } from 'react';
import RadioButton from '../../Shared/RadioButton/RadioButton';
import './SchoolAddress.scss';
import iconDelete from '../../../assets/images/delete.png';
import { DELETE_SCHOOL_MODAL } from 'src/settings/settings';
import { useDispatch, useSelector } from 'react-redux';
import { openModal } from 'src/redux/modules/modals/actions';
import {
  updateSelectedSchool,
  getSelectedSchool,
} from 'src/redux/modules/schoolSelection';

const SchoolAddress = ({ school, noOfSchools, onSchoolClick }) => {
  const dispatch = useDispatch();
  const selectedSchool = useSelector(getSelectedSchool);

  useEffect(() => {
    if (noOfSchools === 1) {
      dispatch(updateSelectedSchool(school));
    }
  }, [dispatch, noOfSchools, school]);

  return (
    <div key={school.schoolName} className="school-address">
      <div className="school-data blocked_data">
        <div
          className="school-radio"
          data-testid={`school-radio-${school.schoolName}`}
        >
          <RadioButton
            category="addSchoolSelection"
            checked={selectedSchool && selectedSchool.id === school.id}
            disabled={false}
            tabIndex={'0'}
            value={school.schoolName}
            onClick={() => onSchoolClick(school)}
          />
        </div>
        <div className="address-delete-container blocked_data">
          <div className="college-title-style">{school.schoolName}</div>
          <div className="college-address-container">
            <div>
              <span>
                {school.addressLineOne}
                {school.addressLineTwo && (
                  <span>
                    <br />
                    {school.addressLineTwo}
                  </span>
                )}
              </span>
            </div>
            <div>
              <span>
                {school.city}, {school.state}{' '}
              </span>
              <span>
                {school.zipExt ? (
                  <span>
                    {school.zip}-{school.zipExt}
                  </span>
                ) : (
                  <span>{school.zip}</span>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <button
          className="school_delete_btn"
          data-testid="school_delete_btn"
          disabled={
            !(selectedSchool && selectedSchool.schoolName === school.schoolName)
          }
          onClick={() => dispatch(openModal(DELETE_SCHOOL_MODAL))}
        >
          <img alt="delete" src={iconDelete} />
        </button>
      </div>
    </div>
  );
};

export default SchoolAddress;
